import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { removeCustomPlan } from "../api/removeCustomPlan";

export const useRemoveCustomPlan = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (companyId) => removeCustomPlan(companyId),
    onSuccess: () => {
      toast.success("Custom plan removed successfully!");
      queryClient.invalidateQueries({ queryKey: ["subscriptionDetails"] });
      queryClient.invalidateQueries({ queryKey: ["allSubscriptions"] });
    },
    onError: (error) => {
      toast.error(error.message || "Failed to remove custom plan.");
    },
  });
};

